import Vue from 'vue';

Vue.filter('gender', (value: string) => {
  if (!value) {
    return '<n/a>';
  }

  if (value === 'male') {
    return 'Männlich';
  }
  if (value === 'female') {
    return 'Weiblich';
  }

  return value;
});
